<div class="setting-page">
  <div class="normalization-groups">
    <legend>Normalization Groups</legend>

    <div class="search-and-actions">
      <div class="search-container">
        <client-filter (onFilter)="onFilter($event)"></client-filter>
      </div>

      <div class="action-buttons">
        <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                        (refreshClick)="refresh()"
                        (deleteClick)="removeItem()" [disableDelete]="!selection || isUnauthorized"
                        (editClick)="editItem()" [disableEdit]="!selection">
        </arm-action-bar>
      </div>
    </div>

    <div class="normalization-groups-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" [data]="items"
                 [isMultipleSelection]="false"
                 [isClientSide]="true" [filter]="filter"></arm-table>
    </div>
  </div>
</div>
